import React, { useCallback } from 'react'

import { func, string } from 'prop-types'

import { getFeatureFilter } from 'Pods/SearchPage/Shared/Tracking/constants'
import { useTrackFilterSelect } from 'Pods/SearchPage/Shared/Tracking/FilterTracking'
import useTranslate from 'Pods/SearchPage/Shared/useTranslate'
import { useSearchPageStore } from 'Pods/SearchPage/Store/index'

import FilterChip from '../../../Shared/FilterChip/FilterChip'

// Extracted so each chip subscribes only to the slice it cares about - sibling
// toggles don't trigger this row's re-render.
function TechnicalAttributesChip({ chipKey, select, onChange }) {
  const t = useTranslate()

  const isChecked = useSearchPageStore(select)
  const trackFilterSelect = useTrackFilterSelect()

  const handleChange = useCallback((nextChecked) => {
    if (nextChecked) {
      const { name, value } = getFeatureFilter(chipKey)
      trackFilterSelect(name, value)
    }
    onChange(nextChecked)
  }, [chipKey, onChange, trackFilterSelect])

  return (
    <FilterChip
      id={`technical-attr-${chipKey}`}
      label={t(`search_page.filters.technical_attributes.${chipKey}`)}
      isChecked={isChecked}
      onChange={handleChange}
    />
  )
}

TechnicalAttributesChip.propTypes = {
  chipKey: string.isRequired,
  select: func.isRequired,
  onChange: func.isRequired,
}

export default TechnicalAttributesChip
